import { registerErrorMiddleware, useErrorStore } from '@ohmybible/core';

import AccessDeniedPage from '../pages/AccessDeniedPage.vue';
import NotFoundPage from '../pages/NotFoundPage.vue';
import ServerErrorPage from '../pages/ServerErrorPage.vue';
import { createRouter, createWebHistory } from 'vue-router';
import { authMiddleware } from '../middlewares/auth';
import { permissionMiddleware } from '../middlewares/permission';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({
    top: 0,
  }),
  routes: [
    {
      path: '/access-denied',
      name: 'AccessDenied',
      component: AccessDeniedPage,
      meta: {
        layout: 'empty',
        public: true,
      },
    },
    {
      path: '/server-error',
      name: 'ServerError',
      component: ServerErrorPage,
      meta: {
        layout: 'empty',
        public: true,
      },
    },
    // Catch-all 404 route - must be registered last
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFoundPage,
      meta: {
        layout: 'main',
      },
    },
  ],
});

// Clear stale errors first, before any guards that may set new ones
registerErrorMiddleware(router);
router.beforeEach(authMiddleware);
// Runs only when auth let the navigation through (a redirect ends it there).
router.beforeEach(permissionMiddleware);

// Handle chunk loading errors after rebuild
router.onError((error) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module')
    || error.message.includes('Importing a module script failed')
  ) {
    const errorStore = useErrorStore();
    errorStore.setError({
      statusCode: 418,
      title: 'Application Updated',
      description:
        'A new version of the application has been released. Please reload the page to get the latest updates.',
      critical: true,
    });
  }
});

export default router;
